function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { closeConfirmation, closeModal, getFullUserDetails, openConfirmation } from "@common/actions/index";
import Spinner from "@common/components/Spinner";
import request from "@common/services/request";
import { openModal } from "@common/actions";
import { CANCEL_SUBSCRIPTION, COMPONENT_PAYMENT, MISSING_INFO, ROUTE_ORDER_SUBSCRIPTIONS, SNACKBAR_AUTOHIDE_TIMEOUT, SNACKBAR_VARIANT_ERROR, SNACKBAR_VARIANT_SUCCESS, STATUS_CODE_SUCCESS, SUBSCRIPTION_ACTIVE } from "@config/constants";
import { Button } from "@material-ui/core";
import { isEmpty } from "lodash";
import { withSnackbar } from "notistack";
import React, { useCallback, useState } from "react";
import { connect } from "react-redux";
import { isBillingValid } from "@common/utils/helpers";
/**
 *
 * @param {{
 *  showActiveText: boolean
 *  active: boolean
 *  onCancel: function
 *  onRenew: function
 *  disableCancel: boolean
 * }} props
 * @returns
 */ function ToggleSubscription(props) {
    var _useState = _sliced_to_array(useState(false), 2), isContinuationRequestPending = _useState[0], setIsContinuationRequestPending = _useState[1];
    var showActiveText = props.showActiveText, active = props.active, onCancel = props.onCancel, onRenew = props.onRenew, onPaymentError = props.onPaymentError, i18n = props.i18n, terminationDate = props.terminationDate, disableCancel = props.disableCancel, userDetails = props.userDetails, _$getFullUserDetails = props.getFullUserDetails, enqueueSnackbar = props.enqueueSnackbar, _$openConfirmation = props.openConfirmation, _$closeConfirmation = props.closeConfirmation, _$openModal = props.openModal;
    var renewSubscription = useCallback(/*#__PURE__*/ _async_to_generator(function() {
        return _ts_generator(this, function(_state) {
            if (isContinuationRequestPending) return [
                2
            ];
            if (isEmpty(userDetails === null || userDetails === void 0 ? void 0 : userDetails.paymentMethod) || !isBillingValid(userDetails === null || userDetails === void 0 ? void 0 : userDetails.billingAddress)) {
                onPaymentError === null || onPaymentError === void 0 ? void 0 : onPaymentError();
                // toggleComponent(COMPONENT_PAYMENT.componentName, COMPONENT_PAYMENT.additionalProps);
                props.openModal(MISSING_INFO, {
                    forceShow: true,
                    confirmButtonText: i18n.account.continue,
                    onSuccess: function() {
                        updateSubscription();
                    }
                });
            } else {
                updateSubscription();
            }
            return [
                2
            ];
        });
    }));
    var updateSubscription = function() {
        var _ref = _async_to_generator(function() {
            var _userDetails_subscription_, _userDetails_subscription, planId, orderData, response, error;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        planId = userDetails === null || userDetails === void 0 ? void 0 : (_userDetails_subscription = userDetails.subscription) === null || _userDetails_subscription === void 0 ? void 0 : (_userDetails_subscription_ = _userDetails_subscription[0]) === null || _userDetails_subscription_ === void 0 ? void 0 : _userDetails_subscription_.planId;
                        orderData = {
                            plan: planId
                        };
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            5,
                            ,
                            6
                        ]);
                        setIsContinuationRequestPending(true);
                        return [
                            4,
                            request({
                                method: "put",
                                url: "users/me/subscription",
                                data: orderData
                            })
                        ];
                    case 2:
                        response = _state.sent();
                        if (!(response.status === STATUS_CODE_SUCCESS)) return [
                            3,
                            4
                        ];
                        return [
                            4,
                            _$getFullUserDetails()
                        ];
                    case 3:
                        _state.sent();
                        enqueueSnackbar(i18n.snackbar.continueSubscriptionSuccess, {
                            variant: SNACKBAR_VARIANT_SUCCESS,
                            autoHideDuration: SNACKBAR_AUTOHIDE_TIMEOUT
                        });
                        setIsContinuationRequestPending(false);
                        _state.label = 4;
                    case 4:
                        return [
                            3,
                            6
                        ];
                    case 5:
                        error = _state.sent();
                        enqueueSnackbar(i18n.errors["error".concat(error.subcode)], {
                            variant: SNACKBAR_VARIANT_ERROR,
                            autoHideDuration: SNACKBAR_AUTOHIDE_TIMEOUT
                        });
                        setIsContinuationRequestPending(false);
                        return [
                            3,
                            6
                        ];
                    case 6:
                        return [
                            2
                        ];
                }
            });
        });
        return function updateSubscription() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ _jsx("div", {
        className: "toggle-subscription",
        children: active ? /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                showActiveText && /*#__PURE__*/ _jsxs("div", {
                    className: "active-wrapper",
                    children: [
                        /*#__PURE__*/ _jsx("span", {
                            className: "icon icon-done active-check"
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "active-text",
                            children: i18n.account.statusActive
                        })
                    ]
                }),
                !disableCancel && /*#__PURE__*/ _jsxs("div", {
                    className: "cancel-wrapper",
                    onClick: onCancel,
                    children: [
                        /*#__PURE__*/ _jsx("span", {
                            className: "icon icon-clear cancel-x pointer"
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "cancel-text",
                            children: i18n.common.remove
                        })
                    ]
                })
            ]
        }) : /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: "column",
                    children: [
                        /*#__PURE__*/ _jsx("span", {
                            className: "deactivated-text",
                            children: i18n.account.statusDeactivated
                        }),
                        /*#__PURE__*/ _jsxs("span", {
                            className: "deactivation-message",
                            children: [
                                "".concat(i18n.subscription.notGoingToRenewAndWillBeTerminatedOn, " "),
                                /*#__PURE__*/ _jsx("span", {
                                    className: "deactivation-date",
                                    children: terminationDate
                                })
                            ]
                        })
                    ]
                }),
                i18n.common.brand !== "tPLAY" && /*#__PURE__*/ _jsx(Button, {
                    classes: {
                        label: "ux-button-label"
                    },
                    className: "button raised half-width pointer renew-button",
                    onClick: function() {
                        _$openConfirmation({
                            message: i18n.account.areYouSureRenewSubscription,
                            declineMethod: _$closeConfirmation,
                            highlightConfirm: true,
                            flipButtons: true,
                            confirmMethod: function() {
                                renewSubscription();
                                _$closeConfirmation();
                            }
                        });
                    },
                    children: isContinuationRequestPending ? /*#__PURE__*/ _jsx(Spinner, {}) : i18n.account.renew
                })
            ]
        })
    });
}
var mapStateToProps = function(param) {
    var i18n = param.i18n, userDetails = param.userDetails;
    return {
        i18n: i18n,
        userDetails: userDetails
    };
};
var mapDispatchToProps = {
    getFullUserDetails: getFullUserDetails,
    openConfirmation: openConfirmation,
    closeConfirmation: closeConfirmation,
    openModal: openModal
};
export default withSnackbar(connect(mapStateToProps, mapDispatchToProps)(ToggleSubscription));
